import { createAsyncThunk, isRejectedWithValue } from '@reduxjs/toolkit'
import axios from 'axios'
import { AxiosClient } from 'src/redux/AxiosClient'

export const createRFPProjectInformationAsync = createAsyncThunk(
  'rfxManagement/rfp/createProjectInformationAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/create-new-project', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getColorPaletteAsync = createAsyncThunk(
  'bidAnalysis/colorPalette/getColorPaletteAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/bid-analysis/get-color-palette', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const setColorPaletteAsync = createAsyncThunk(
  'bidAnalysis/colorPalette/setColorPaletteAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/bid-analysis/set-color-palette', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const generateFeedbackPreviewAsync = createAsyncThunk(
  'v1/feedback-generation/preview-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/feedback-generation/preview-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const deleteBaselineFile = createAsyncThunk(
  'v1/rfp-analysis/delete-proof-of-approval-file',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/delete-proof-of-approval-file', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const whitelistIpAsync = createAsyncThunk(
  'rfxManagement/rfx/whitelistIpAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/whitelist-ip', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const editRFPProjectInformationAsync = createAsyncThunk(
  'rfxManagement/rfp/createProjectInformationAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/edit-project-details', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getTagsAndColorsAsync = createAsyncThunk(
  'rfxAnalysis/getTagsAndColorsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/rfx-analysis/get-tags-and-colors', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getRFPFileDataAsync = createAsyncThunk(
  'rfxManagement/rfp/getRFPFileDataAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-analysis-data', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const deleteTagsAndColorsAsync = createAsyncThunk(
  'rfxManagement/rfp/deleteTagsAndColorsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/delete-vendor-tags', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getTagsAsync = createAsyncThunk(
  'rfxManagement/rfp/getTagsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-tags', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getBidAnalysisKPIsAsync = createAsyncThunk(
  'rfxManagement/rfp/getBidAnalysisKPIsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-bid-analysis-kpis', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getRFPFiltersDataAsync = createAsyncThunk(
  'rfxManagement/rfp/getRFPFiltersDataAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-filters-data', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getAwardScenarioDataAsync = createAsyncThunk(
  'awardScenario/getAwardScenarioDataAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/award-scenario/get-scenario-data', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getAwardScenarioTableDataAsync = createAsyncThunk(
  'award-scenario/get-award-scenario-table-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/award-scenario/get-award-scenario-table-data', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getSupplierDropdownForPartsAsync = createAsyncThunk(
  'awardScenario/getSupplierDropdownForPartsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/award-scenario/get-supplier-dropdown-for-parts',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const saveAwardScenarioAsync = createAsyncThunk(
  'awardScenario/saveAwardScenarioAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/award-scenario/save-award-scenario', payload, {
      dispatch,
      rejectWithValue,
      isRejectWithErrorMsg: true,
      fulfillWithValue,
    })
  },
)

export const downloadFeedbackFilesAsync = createAsyncThunk(
  'rfxManagement/rfp/downloadFeedbackFilesAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/feedback-generation/download-vendorwise-feedback',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const getSavingsByPartsAsync = createAsyncThunk(
  'rfxManagement/rfp/getSavingsByPartsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/savings-by-parts', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getSasTokenAsync = createAsyncThunk(
  'rfxManagement/rfp/getSasTokenAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-sas-token', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getSavingByBidSupplierAsync = createAsyncThunk(
  'rfxManagement/rfp/getSavingByBidSupplierAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/saving-by-bid-supplier', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getSavingAgainstIncumbentAsync = createAsyncThunk(
  'rfxManagement/rfp/getSavingAgainstIncumbentAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/saving-againts-incumbent', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const saveProductViewScenarioAsync = createAsyncThunk(
  'rfxManagement/rfp/saveProductViewScenarioAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/save-product-view-scenario', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getScenarioNames = createAsyncThunk(
  'rfxManagement/rfp/getScenarioNames',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-scenario-names', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getPartAnalysis = createAsyncThunk(
  'rfxManagement/bid-analysis/get-part-analysis-table',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/bid-analysis/get-part-analysis-table', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getPartAnalysisFilter = createAsyncThunk(
  'rfxManagement/bid-analysis/get-part-analysis-table-filters',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/bid-analysis/get-part-analysis-table-filters', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getScenarioData = createAsyncThunk(
  'rfxManagement/rfp/getScenarioData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-scenario-data', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getProjectsDetailsAsync = createAsyncThunk(
  'rfxManagement/rfp/getProjectsDetailsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-project-details', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// RFI project details KPIs
export const getRFPProjectDetailsKPIsAsync = createAsyncThunk(
  'rfxManagement/rfp/project-details/kpis',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-project-details-kpi', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const downloadVendorBidFileAsync = createAsyncThunk(
  'rfxManagement/rfp/project-details/download-vendor-bid-file',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/download-vendor-bid-file', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
export const getInvalidBidReasonsAsync = createAsyncThunk(
  'rfxManagement/rfp/project-details/get-invalid-bid-reasons',
  (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return AxiosClient('POST', '/v1/rfp-analysis/get-invalid-bid-reasons', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Upload Vendors
export const uploadVendorsAsync = createAsyncThunk(
  'rfxManagement/rfp/project-details/upload-vendors',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/upload-suppliers', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//Download consolidated file
export const downloadConsolidatedRFPAsync = createAsyncThunk(
  'rfxManagement/rfi/rfp-analysis/get-consolidated-bids',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-consolidated-bids', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get consolidation status
export const getConsolidationStatusAsync = createAsyncThunk(
  'rfxManagement/rfi/rfp-analysis/get-consolidation-status',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-consolidation-status', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//generate consolidation again
export const generateConsolidation = createAsyncThunk(
  'rfxManagement/rfi/project-details/genarate-consolidated-bids',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/genarate-consolidated-bids', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Async for send RFP mail
export const sendRFPEmailAsync = createAsyncThunk(
  'rfxManagement/rfp/project-details/sendRFPEmailAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/send-rfp-mail', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const sendRFPEmailCommunicationAsync = createAsyncThunk(
  'rfxManagement/rfp/project-details/send-communication',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/send-communication', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const sendRFPTestMailAsync = createAsyncThunk(
  'rfxManagement/rfp/project-details/send-test-mail',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/send-test-mail', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//Async for Table in project deatil page
export const getProjectVendorsDataAsync = createAsyncThunk(
  'rfxManagement/rfp/project-details/get-all-vendor-details-with-responses',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      'v1/rfp-analysis/get-all-vendor-details-with-responses',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

//Get uploaded vendor error status
export const downloadVendorsWithErrorsStatus = createAsyncThunk(
  'rfxManagement/rfp/project-details/download-vendors-with-errors-status',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/check-file-status', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//Download uploaded vendors with errors
export const downloadVendorsWithErrors = createAsyncThunk(
  'rfxManagement/rfp/project-details/download-vendors-with-errors-status',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/download-supplier-upload-error-file',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//project round
export const GetProjectRoundAsync = createAsyncThunk(
  'rfxManagement/rfp/rfp-project-round',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-project-rounds', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//shortlist vendors
export const ShortlistVendorsAsync = createAsyncThunk(
  'rfxManagement/rfp/shortlist-vendors',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/vendor-selection-for-nextRound', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//shortlist vendors
export const ShortlistVendorAsync = createAsyncThunk(
  'rfxManagement/rfp/shortlist-vendor',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/vendor-shortlist', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//add vendors to rfp
export const AddVendorsToRFPProject = createAsyncThunk(
  'rfxManagement/rfp/add-to-rfp',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/add-vendors-to-rfp', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Upload feedback
export const UploadFeedbackAsync = createAsyncThunk(
  'rfxManagement/rfp/upload-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/upload-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//Upload FeedBack for multiple Sheet and Single standard sheet
export const UploadFeedbackForMultipleSheetAsync = createAsyncThunk(
  'rfxManagement/rfp/upload-feedback-for-multiple-sheet',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v2/rfp-analysis/upload-rfp-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const UploadShareFeedbackFileAsync = createAsyncThunk(
  'rfxManagement/rfp/feedback-generation/upload-feedback-file',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/feedback-generation/upload-feedback-file', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const saveAndProceedShareFeedbackFileAsync = createAsyncThunk(
  'rfxManagement/rfp/feedback-generation/save-feedback-sheet-mapping',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/feedback-generation/save-feedback-sheet-mapping',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

//download zip for multipleSheet In Feedback
export const exportFeedbackMultipleVendors = createAsyncThunk(
  'rfxManagement/rfp/v1/rfp-analysis/export-feedback-multiple-vendors',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/export-feedback-multiple-vendors', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//save configuration Data of the feedback file
export const saveConfigurationForFeedbackAsync = createAsyncThunk(
  'rfxManagement/rfp/save-configuration-for-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/submit-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getMultipleSheetDownloadFilesData = createAsyncThunk(
  'rfxManagement/rfp/api/v1/rfp-analysis/export-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/export-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//vendor-file-list
export const VendorFileList = createAsyncThunk(
  'rfxManagement/rfp/vendor-file-list',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/vendor-file-list', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Attached bid sheet list
export const getBidSheetList = createAsyncThunk(
  'rfxManagement/rfp/get-rfp-templates-list',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-rfp-templates-list', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//download-files
export const DownloadFilesAsync = createAsyncThunk(
  'rfxManagement/rfp-analysis/download-files',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/download-files',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
      'blob',
    )
  },
)

//download-rfp-bidSheets
export const DownloadBidSheetFiles = createAsyncThunk(
  'rfxManagement/rfp/download-rfp-templates-lis',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/download-rfp-templates-list',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
      'blob',
    )
  },
)

//delete additional files
export const DeleteAdditionalFiles = createAsyncThunk(
  'rfxManagement/rfp/delete_file',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/delete_file', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//change round
export const ChangeRound = createAsyncThunk(
  'rfxManagement/rfp/update-rounds-file',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/update-rounds-file', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// upload RFP and additional files
export const UploadFilesAsync = createAsyncThunk(
  'rfxManagement/rfp-analysis/upload-files',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/upload-files', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectedWithValue: true,
    })
  },
)
// cancel RFP and additional files
export const cancelUploadFilesAsync = createAsyncThunk(
  'rfxManagement/rfp-analysis/upload-files-cancel',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/upload-files/abort', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectedWithValue: true,
    })
  },
)

export const UploadFilesAsyncv2 = createAsyncThunk(
  'rfxManagement/rfp-analysis/upload-files',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/upload-files_v2', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectedWithValue: true,
    })
  },
)

//list-request-for-vendors
export const getRequestVendorList = createAsyncThunk(
  'rfxManagement/rfp/list-request-vendors',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/list-request-for-vendor', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//approve-request-for-vendor-request
export const approveVandorRequest = createAsyncThunk(
  'rfxManagement/rfp/approve-request-for-multiple-contacts',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/approve-request-for-multiple-contacts',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//Get filled bid sheet for vendor
export const GetContactDetailsforVendorAsync = createAsyncThunk(
  'rfxManagement/rfp/get-contact-details-for-vendor',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-rfp-project-contacts', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Get filled bid sheet for vendor
export const UpdateContactforVendorAsync = createAsyncThunk(
  'rfxManagement/rfp/update-contatct-for-vendor',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/add-rfp-contact', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Upload or select rfp bid sheet, additional files
export const uploadRfpTemplatesAsync = createAsyncThunk(
  'rfxManagement/rfp/uploadTemplates',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v2/rfp-analysis/upload-template', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Upload or select rfp bid sheet, additional files
export const uploadRfpTemplatesAsyncv2 = createAsyncThunk(
  'rfxManagement/rfp/uploadTemplates',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v2/rfp-analysis/upload-template_v2', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Get rfp templates and additional files for RFP project
export const getRFPTemplatesListAsync = createAsyncThunk(
  'rfxManagement/rfp/getRFPTemplatesListAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-rfp-templates', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get common URL
export const getCommonURL = createAsyncThunk(
  'rfxManagement/rfp/generate-common-url',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/generate-common-url', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Change status
export const ChangeStatus = createAsyncThunk(
  'rfxManagement/rfp/change-status',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/change-status', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Get rfp templates and additional files for RFP project
export const downloadBidTemplateAsync = createAsyncThunk(
  'rfxManagement/rfp/download-bidsheet-Async',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/download-blob-file', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Delete RFP vendors from project
export const deleteRFPVendorsFromProjectAsync = createAsyncThunk(
  'rfxManagement/rfp/delete-RFP-vendors-from-project',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/delete-vendor', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Download Feedback Template for RFP
export const downloadRFPFeedbackTemplateAsync = createAsyncThunk(
  'rfxManagement/rfp/download-RFP-feedback-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/rfp-analysis/download-file', [], {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Check RFP Feedback Status
export const checkRFPFeedbackStatusAsync = createAsyncThunk(
  'rfxManagement/rfp/check-RFP-feedback-status',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/check-feedback-status', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getFeedbackValidationTable = createAsyncThunk(
  'rfxManagement/rfp/getFeedbackValidation',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-feedback-data', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const downloadAllFeedbackValidation = createAsyncThunk(
  'rfxManagement/rfp/feedback-generation/download-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      'v1/rfp-analysis/download-feedback',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
      'blob',
    )
  },
)
export const downloadVendorFeedbackValidation = createAsyncThunk(
  'rfxManagement/rfp/feedback-generation/download-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/download-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Send RFP feedback mail to vendors
export const sendRFPFeedbackMailtoVendorsAsync = createAsyncThunk(
  'rfxManagement/rfp/send-RFP-feedback-mail-to-vendors',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v2/rfp-analysis/send-rfp-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Get generated feedback
export const getGeneratedFeedback = createAsyncThunk(
  'rfxManagement/rfp/get-generated-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/generate-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Change default mail template
export const changeDefaultTemplate = createAsyncThunk(
  'rfxManagement/rfp/default-email-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/default-email-template', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Change default mail template
export const getDefaultTemplate = createAsyncThunk(
  'rfxManagement/rfp/get-email-templates',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/get-email-templates', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      // isRejectWithErrorMsg: true,
    })
  },
)

export const getSheetsNamesForConsolidation = createAsyncThunk(
  'rfpAnalysis/getSheetsNamesForConsolidation',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await AxiosClient(
        'POST',
        '/v1/rfp-analysis/get-sheets-names-for-consolidation',
        payload,
        { dispatch, rejectWithValue, fulfillWithValue },
      )
      return response
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

export const getConsolidationFilePath = createAsyncThunk(
  'rfpAnalysis/getConsolidationFilePath',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await AxiosClient(
        'POST',
        '/v1/rfp-analysis/get-consolidation-filepath',
        payload,
        { dispatch, rejectWithValue, fulfillWithValue },
      )
      return response
    } catch (error) {
      console.error('Error fetching consolidation file path:', error)
      return rejectWithValue(error.message)
    }
  },
)

export const downloadConsolidation = createAsyncThunk(
  'rfpAnalysis/downloadConsolidation',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await AxiosClient(
        'POST',
        '/v1/rfp-analysis/download_consolidation',
        payload,
        { dispatch, rejectWithValue, fulfillWithValue },
      )
      return response
    } catch (error) {
      console.error('Error downloading consolidation file:', error)
      return rejectWithValue(error.message)
    }
  },
)

// Calculate feedback
export const calculateFeedbackAsync = createAsyncThunk(
  'rfpAnalysis/calculate-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/calculate-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Get feedback files
export const getFeedbackFilesAsync = createAsyncThunk(
  'rfpAnalysis/get-feedback-files',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-feedback-files', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Get feedback files
export const downloadConsolidationAsync = createAsyncThunk(
  'rfpAnalysis/download-consolidation',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/download_consolidation', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Get All Question for RFP
export const getAllQuestionForRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/all-question-for-Async',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-all-questions-project', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Get All Question for RFP Newflow
export const getAllNewQuestionForRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/v1/qna/get-unanswered-question-count',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/qna/get-unanswered-question-count', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
//get All Consolidated for RFP

export const getAllConsolidatedQuestionForRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/all-consolidated-question-for-Async',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/get-consolidated-question', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//sendRFPEmailAsync

export const sendQnARFPEmailAsync = createAsyncThunk(
  'rfxManagement/rfp-analysis/qna-email-notification',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/qna-email-notification', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//edit question-answer for RFP module
export const editAnswerForRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/edit-answer-for-Async',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/update-answer-for-question', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const editConsolidatedAnswerForRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/edit-consolidated-answer-for-Async',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/update-consolidated-question', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//download question answer template excel for RFP module
export const downloadQuestionAnswerExcel = createAsyncThunk(
  'rfp-analysis/download-question-answer-excel',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/download-question-answer-excel', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
// Upload Vendors
export const uploadRfpConfigurationAsync = createAsyncThunk(
  'rfxManagement/rfp/rfp-analysis/upload-rfp-configuration',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/upload-rfp-analysis-template', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const downloadRfpConfigTemplate = createAsyncThunk(
  'rfxManagement/rfp/rfp-analysis/download-rfp-configuration-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/rfp-analysis/download-rfp-analysis-template', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const downloadLandedCostStandardTemplate = createAsyncThunk(
  'v1/landed-cost-analysis/download-rate-card-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      '/v1/landed-cost-analysis/download-rate-card-template',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get field cofigurations data
export const getFieldConfigurationsData = createAsyncThunk(
  'rfxManagement/rfp/project-details/get-field-configuration',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-file-header-mapping', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getRFITemplateHeaderMapping = createAsyncThunk(
  'rfxManagement/rfi/project-details/get-file-header-mapping',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-file-header-mapping', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// save field cofigurations
export const saveFieldsConfiguration = createAsyncThunk(
  'rfxManagement/rfp/project-details/save-field-configurations',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/save-field-configuration', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)
// Get RFP analysis logs
export const rfpAnalysisLogsAsync = createAsyncThunk(
  'rfp-analysis/rfp-analysis-logs',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-rfp-logs', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Validate project for bid analysis
export const validateProjectAsync = createAsyncThunk(
  'rfp-analysis/validate-project',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/validate-project', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Run bid analysis
export const runBidAnalysisAsync = createAsyncThunk(
  'rfp-analysis/run-analysis',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/generate-rfp-analysis', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
// Run custom bid analysis
export const runCustomScenarioBidAnalysisAsync = createAsyncThunk(
  'rfp-analysis/run-and-upload-custom-bid-analysis',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/upload-custom-bid-analysis-template',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)
//Reminder in rfp get event dropdown data

export const getAllEventDropDownDataForRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/event-dropdowndata-for-RFPAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', 'v1/rfp-analysis/events', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// submit in rfp add reminder data
export const addNewRemainderDataForRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/add-new-reminder-for-RFPAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/set-reminders', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//update reminder for rfp
export const updateRemainderDataForRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/update-reminder-for-RFPAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/update-reminders', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//getAll reminders table data

export const getAllRemindersDataForRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/get-reminder-data-for-RFPAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `v1/rfp-analysis/get-reminders`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//delete reminders

export const deleteRemindersDataForRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/delete-reminder-data-for-RFPAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `v1/rfp-analysis/delete-reminders`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Get scenario list custom scenario in bid analysis
export const getReferenceScenarioList = createAsyncThunk(
  'rfp-analysis/custom-scenario/reference-custom-scenario-list',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-custom-scenario-list', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
// Download shortlist bidder template in bid analysis
export const downloadShortlistBidderTemplate = createAsyncThunk(
  'rfp-analysis/custom-scenario/download-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/download-shortlist-bidder-template',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// Download last uploaded file for bid analysis configuration
export const downloadLastUploadedRFPConfigFile = createAsyncThunk(
  'rfp-analysis/baseline-upload/download-last-uploaded-file',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/download-bid-analysis-updated-file',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

// Set RFP configuration from last round
export const setRFPConfigFromLastRound = createAsyncThunk(
  'rfp-analysis/baseline-upload/rfp-config-from-last-round',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/get-rfp-bid-analysis-last-updated',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//email status tracker

export const getRFPVendorEmailStatus = createAsyncThunk(
  'rfp-analysis/get-mail-data-for-vendors',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-mail-data-for-vendors', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Refresh status
export const refreshRFPVendorEmailStatus = createAsyncThunk(
  'rfp-analysis/refresh-mail-status',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/refresh-mail-status', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Upload Intermediate file
export const uploadIntermediateFile = createAsyncThunk(
  'rfp-analysis/intermediate-file/upload',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/upload-intermediate-file', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Generate intermediate file
export const generateIntermediateFile = createAsyncThunk(
  'rfp-analysis/intermediate-file/generate',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/trigger-intermediate-file-analysis',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// Get intermediate file logs
export const getIntermediateFileLogs = createAsyncThunk(
  'rfp-analysis/intermediate-file/logs',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-intermediate-file-data', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getProjectAndScenarioNamesBidAnalysisAsync = createAsyncThunk(
  'bid-analysis/get-project-and-scenario-names',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/rfp-analysis/get-project-scenario-data', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const insertDeleteTagsAsync = createAsyncThunk(
  'bid-analysis/get-insert-update-tags-async',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/add-vendor-tags', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getBidAnalysisHistoryAsync = createAsyncThunk(
  'rfxManagement/rfp/rfp-analysis/get-latest-baseline-approve',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/get-latest-baseline-approve', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)
export const uploadBidAnalysisProofAsync = createAsyncThunk(
  'rfxManagement/rfp/rfp-analysis/upload-proof-of-approval',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/upload-baseline-approval-proof', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const uploadBidLandedCostAsync = createAsyncThunk(
  '/api/v1/landed-cost-analysis/upload-rate-card',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/landed-cost-analysis/upload-rate-card', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const downloadBidAnalysisFiles = createAsyncThunk(
  'rfxManagement/rfp/create-project-download-rfp-templates-list',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/download-rfp-templates-list',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
      'blob',
    )
  },
)

export const saveFeedbackBucketsAsync = createAsyncThunk(
  'feedback-generation/save-feedback-buckets',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/feedback-generation/save-feedback-buckets', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getFeedbackBucketsAsync = createAsyncThunk(
  'feedback-generation/get-feedback-buckets',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/feedback-generation/get-feedback-buckets', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const deleteFeedbackBucketsAsync = createAsyncThunk(
  'feedback-generation/delete-feedback-buckets',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('DELETE', '/v1/feedback-generation/delete-feedback-buckets', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getBidSheetHistory = createAsyncThunk(
  'rfxManagement/rfp/get-bidSheet-history',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/get-rfp-templates-list-with-history',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)
export const downloadRfiStandardTemplate = createAsyncThunk(
  'rfxManagement/v1/rfx-analysis/download-standard-rfi-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/rfx-analysis/download-standard-rfi-template', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const generateRFPFeedback = createAsyncThunk(
  'rfxManagement/rfp/generate-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/feedback-generation/calculate-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//upload feedback template
export const getFeedbackTemplate = createAsyncThunk(
  'rfxManagement/rfp/get-feedback-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/feedback-generation/get-feedback-template-file',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

//upload feedback template
export const uploadFeedbackTemplate = createAsyncThunk(
  'rfxManagement/rfp/upload-feedback-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/feedback-generation/upload-feedback-template', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const saveRFPFeedback = createAsyncThunk(
  'rfxManagement/rfp/save-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/feedback-generation/save-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const saveApplicationLevelEmailTemplate = createAsyncThunk(
  'v1/rfx-analysis/update-default-email-templates',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/update-default-email-templates', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//get-vendor-feedback
export const getVendorWiseFeedback = createAsyncThunk(
  'rfxManagement/rfp/feedback-generation/get-vendor-wise-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/feedback-generation/get-vendor-wise-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//send-vendor-feedback
export const sendVendorWiseFeedback = createAsyncThunk(
  'rfxManagement/rfp/feedback-generation/share-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/feedback-generation/share-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)
export const sendShareVendorWiseFeedback = createAsyncThunk(
  'rfxManagement/rfp/feedback-generation/share-outside-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/feedback-generation/share-outside-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Update feedback data
export const updateFeedbackData = createAsyncThunk(
  'rfxManagement/rfp/feedback-generation/update-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/feedback-generation/update-calculated-feedback',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

// Update feedback data
export const getAttributePricingList = createAsyncThunk(
  'rfxManagement/rfp/feedback-generation/attribute-pricing-list',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-attribute-pricing-list', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const downloadPreviewFeedbackAsync = createAsyncThunk(
  'rfxManagement/rfp/feedback-generation/download-preview-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/feedback-generation/download-preview-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getFilenameAsync = createAsyncThunk(
  'rfxManagement/rfp/getFilenameAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-filename', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const validateFeedbackMethodAsync = createAsyncThunk(
  'rfxManagement/rfp/feedback-generation/validate-feedback-method',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/feedback-generation/feedback-method-validation',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

export const saveProcurementConfigAsync = createAsyncThunk(
  'rfp/procurement/saveProcurementConfig',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/add-ip-for-file-preview', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getQnADataAsync = createAsyncThunk(
  'rfxManagement/rfp/getQnADataAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/qna/get-qna-data', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const previewQAndAUpload = createAsyncThunk(
  'rfxManagement/rfp/previewQAndAUpload',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/qna/preview-questions', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getBaselineFileHistoryAsync = createAsyncThunk(
  'rfp/getBaselineFileHistoryAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/get-baseline-template-history', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getQNAPreviewData = createAsyncThunk(
  'rfxManagement/rfp/getQNAPreviewData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/qna/preview-questions', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const reviewBidsAsync = createAsyncThunk(
  'rfxManagement/bid-analysis/reviewBidsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/bid-analysis/review-bids', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const uploadQNAPreviewData = createAsyncThunk(
  'rfxManagement/rfp/uploadQNAPreviewData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/qna/upload-question-answers', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getSuppliersDetailsAsync = createAsyncThunk(
  'rfxManagement/bid-analysis/getSuppliersDetailsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/bid-analysis/get-suppliers-details', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getFiltersAsync = createAsyncThunk(
  'rfxManagement/bid-analysis/getFiltersAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/bid-analysis/get-filters', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const editAwardScenarioAsync = createAsyncThunk(
  'rfxManagement/award-scenario/editAwardScenarioAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/award-scenario/edit-scenario', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getSupplierBidInfoAsync = createAsyncThunk(
  'rfxManagement/bid-analysis/getSupplierBidInfoAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/bid-analysis/get-supplier-bid-info', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const previewOutsideFeedbackAsync = createAsyncThunk(
  'v1/feedback-generation/preview-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/feedback-generation/preview-outside-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//sync vendor contact
export const syncVendorContactAsync = createAsyncThunk(
  'v1/rfp-analysis/sync-supplier-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/sync-supplier-details', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//sync vendor contact
export const restoreBidAsync = createAsyncThunk(
  'v1/rfp-analysis/restore-bid-file',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/restore-bid-file', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getFileBlobAsync = createAsyncThunk('file/get-file-blob', async (payload) => {
  const response = await axios.get(`${import.meta.env.VITE_API_URL}/file`, {
    params: { filepath: payload?.path },
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('accesstoken')}`,
    },
  })

  return response.data
})

// save spreadsheet
export const saveSpreadsheetAsync = createAsyncThunk(
  'v1/rfp-analysis/save-spreadsheet',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/save-spreadsheet', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// open spreadsheet (converted to common AxiosClient format)
export const getSpreadSheet = createAsyncThunk(
  'v1/rfp-analysis/spreadsheet/open',
  async (formData, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/open-spreadsheet', formData, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
)
